module.exports = __webpack_public_path__ + "img/logo_01.4f2fa3c3.png";